import Aos from 'aos'
import React, { useEffect } from 'react'
import { Accordion, Col, Container, Row } from 'react-bootstrap'
import 'aos/dist/aos.css'

export const Faqs = () => {

    useEffect(() => {
        Aos.init({ duration: 1000 })
    })

    const faqs = [
        {
            question: "What types of events do you host at Bhadade Hall?",
            answer:
                "We host all kinds of celebrations — weddings, receptions, engagements, birthday parties, corporate events, and cultural gatherings."
        },
        {
            question: "Can we customize the menu according to our preferences?",
            answer:
                "Absolutely! We work with you to curate a personalized menu that fits your theme, taste, and budget perfectly."
        },
        {
            question: "How far in advance should we book the hall?",
            answer:
                "We recommend booking at least 2–3 months in advance, especially during the wedding and festive seasons, to ensure your preferred date is available."
        },
        {
            question: "Do you provide decoration and event management services?",
            answer:
                "Yes, we offer complete decor and event setup services — including floral decorations, lighting, stage design, and seating arrangements."
        },
        {
            question: "Is parking available at the venue?",
            answer:
                "Yes, we provide spacious parking for guests with proper attendants to guide vehicles during peak hours."
        },
        {
            question: "Do you offer outdoor or lawn booking options?",
            answer:
                "Yes, along with our indoor banquet hall, we have a beautifully maintained lawn area ideal for open-air events and receptions."
        },
        {
            question: "What is included in your catering package?",
            answer:
                "Our catering packages include food preparation, buffet setup, serving staff, and clean-up after the event. Cutlery and dining arrangements are also included."
        },
        {
            question: "Do you arrange live counters or dessert stations?",
            answer:
                "Yes! We offer popular live counters like chaat, dosa, Chinese, and dessert stations to make your event interactive and memorable."
        },
        {
            question: "How do I confirm my booking or get a quotation?",
            answer:
                "You can visit our Contact page, call us directly, or WhatsApp us with your event details — our team will share customized quotes and package options."
        }
    ];


    return (
        <>
            <Container
                fluid
                className="gallery-header d-flex justify-content-start align-items-center"
            >
                <Row>
                    <Col data-aos="fade-up" data-aos-delay="100">
                        <h1 className="gallery-title">FAQ's</h1>
                    </Col>
                </Row>
            </Container>



            <Container fluid style={{
                padding: "2rem"
            }}>
                <Row>
                    <Col>

                        <Accordion data-aos="fade-up" data-aos-delay="100">
                            {faqs.map((faq, index) => (
                                <Accordion.Item eventKey={index.toString()} key={index} style={{ marginBottom: "1.1rem", boxShadow: "0 6px 12px rgba(0,0,0,0.05)", borderRadius: "12px", }}>
                                    <Accordion.Header style={{ fontWeight: "600", fontSize: "1.1rem" }}>
                                        <span style={{
                                            fontWeight: "600",
                                        }}>   {faq.question}</span>
                                    </Accordion.Header>

                                    <Accordion.Body style={{ fontSize: "1rem", color: "#850814" }}>
                                        {faq.answer}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
